/* Builder funnel events. Standard ecommerce events remain owned by Elevar. */
(() => {
  'use strict';
  const GA4_ID = 'G-8H7D8SE070';
  const META_ID = '670900863512285';
  const allowed = purpose => {
    try {
    const privacy = window.Shopify?.customerPrivacy;
    return purpose === 'analytics'
      ? privacy?.analyticsProcessingAllowed?.() === true
      : privacy?.marketingAllowed?.() === true;
    } catch { return false; }
  };
  const sendGoogle = (name, details) => {
    try { window.gtag('event', name, {...details, send_to: GA4_ID}); } catch { /* Keep cart interactions working. */ }
  };
  const sendMeta = (name, details) => {
    try { window.fbq('trackSingleCustom', META_ID, name, details); } catch { /* Keep cart interactions working. */ }
  };
  const emit = (name, params) => {
    const details = {builder_id: '3-for-2', ...params};
    if (allowed('analytics') && typeof window.gtag === 'function') {
      sendGoogle(name, details);
    }
    if (allowed('marketing') && typeof window.fbq === 'function') {
      sendMeta(name, details);
    }
  };

  // Measure internal placements without replacing acquisition UTMs.
  document.addEventListener('click', event => {
    const anchor = event.target.closest?.('a[href]');
    if (!anchor) return;
    const url = new URL(anchor.href, location.origin);
    if (url.origin !== location.origin || url.pathname.replace(/\/$/, '') !== '/pages/3-for-2'
      || location.pathname.replace(/\/$/, '') === '/pages/3-for-2') return;
    const placement = anchor.closest('header, header-drawer, nav') ? 'navigation'
      : location.pathname === '/' ? 'homepage'
      : location.pathname === '/collections/all' ? 'shop_all' : 'other_internal';
    emit('bundle_builder_link_click', {builder_placement: placement});
  });

  if (location.pathname.replace(/\/$/, '') !== '/pages/3-for-2') return;
  customElements.whenDefined('product-bundle').then(() => {
    document.querySelectorAll('bundle-offer-enhancements product-bundle').forEach(bundle => {
      if (bundle.dataset.funnelBound) return;
      bundle.dataset.funnelBound = 'true';
      let visible = false;
      let viewAnalytics = false;
      let viewMarketing = false;
      let lastComplete = '';
      let pending = null;
      const selection = () => Array.from(bundle.querySelectorAll('[data-product-bundle-variant]:not([available])'))
        .map(row => ({
          id: row.getAttribute('data-variant-id'),
          quantity: Number(row.querySelector('quantity-input')?.value || 1)
        })).filter(item => item.id && item.quantity > 0);
      const count = items => items.reduce((sum, item) => sum + item.quantity, 0);
      const view = () => {
        if (!visible) return;
        // A consent change can enable one destination after the other has fired.
        if (!viewAnalytics && allowed('analytics') && typeof window.gtag === 'function') {
          sendGoogle('bundle_builder_view', {builder_id:'3-for-2'});
          viewAnalytics = true;
        }
        if (!viewMarketing && allowed('marketing') && typeof window.fbq === 'function') {
          sendMeta('bundle_builder_view', {builder_id:'3-for-2'});
          viewMarketing = true;
        }
      };
      const checkComplete = () => {
        const items = selection();
        const target = Number(bundle.dataset.maximum || 3);
        const complete = count(items) === target;
        const fingerprint = complete ? JSON.stringify(items) : '';
        if (fingerprint && fingerprint !== lastComplete) {
          emit('bundle_complete', {bundle_size:target, item_count:count(items)});
        }
        lastComplete = fingerprint;
      };
      const observer = new MutationObserver(checkComplete);
      observer.observe(bundle, {subtree:true, childList:true, attributes:true,
        attributeFilter:['available', 'data-variant-id', 'data-selected-count', 'data-maximum']});
      bundle.addEventListener('change', () => setTimeout(checkComplete, 350));
      bundle.addEventListener('click', event => {
        const button = event.target.closest?.('[data-product-bundle-submit]');
        if (!button || button.disabled || button.hasAttribute('aria-disabled')) return;
        const items = selection();
        if (count(items) !== Number(bundle.dataset.maximum || 3)) return;
        pending = {items, started:Date.now()};
      }, true);

      // The theme publishes this only after a successful Shopify cart response.
      window.theme?.pubsub?.subscribe(window.theme.pubsub.PUB_SUB_EVENTS.cartUpdate, data => {
        if (data.source !== 'product-bundle' || !pending) return;
        const request = pending;
        pending = null;
        if (Date.now() - request.started > 60000) return;
        emit('bundle_add_to_bag', {bundle_size:count(request.items), item_count:count(request.items)});
        const root = window.Shopify?.routes?.root || '/';
        // Marks carts that used the builder; it does not claim items remain in the final order.
        fetch(root + 'cart/update.js', {
          method:'POST', credentials:'same-origin', keepalive:true,
          headers:{'Content-Type':'application/json', 'Accept':'application/json'},
          body:JSON.stringify({attributes:{bundle_builder_used:'3-for-2'}})
        }).then(response => {
          if (!response.ok) throw new Error('Builder cart attribution failed: ' + response.status);
        }).catch(error => console.warn(error.message));
      });
      const intersection = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting)) { visible = true; view(); }
      }, {threshold:0.1});
      intersection.observe(bundle);
      document.addEventListener('visitorConsentCollected', view);
      // Account for consent API and destination scripts finishing after the section.
      let attempts = 0;
      const timer = setInterval(() => {
        view();
        if (++attempts >= 30 || (viewAnalytics && viewMarketing)) clearInterval(timer);
      }, 1000);
      checkComplete();
    });
  });
})();
